import React from 'react';
import { useTemplateStore } from '../../stores/templateStore';
import type { BulkUpdates } from '../../types/bulk';
import { BulkApplyButton } from './BulkFieldRow';

interface BulkTemplateSelectorProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkTemplateSelector({ onUpdate }: BulkTemplateSelectorProps) {
  const { templates, activeTemplateId, setActiveTemplate } = useTemplateStore();

  const handleTemplateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const templateId = e.target.value;
    setActiveTemplate(templateId || null);
  };

  const handleApplyTemplate = () => {
    if (!activeTemplateId) return;

    const template = templates.find(t => t.id === activeTemplateId);
    if (!template) return;

    const updates: BulkUpdates = {
      ...template.fields,
      customShippingMethods: [...template.fields.customShippingMethods]
    };

    onUpdate(updates);
  };

  if (templates.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3 p-3 sm:p-4 bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 rounded-lg">
      <select
        value={activeTemplateId || ''}
        onChange={handleTemplateChange}
        className="h-10 min-w-0 flex-1 rounded-md border border-gray-300 bg-white px-3 text-sm"
      >
        <option value="">テンプレートを選択...</option>
        {templates.map(template => (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        ))}
      </select>
      <BulkApplyButton
        disabled={!activeTemplateId}
        onClick={handleApplyTemplate}
      >
        テンプレートを適用
      </BulkApplyButton>
    </div>
  );
}
